import * as i0 from '@angular/core';
import * as i1 from '@angular/platform-browser';
import * as i2 from '@angular/common';
export const BrowserModuleNgFactory:i0.NgModuleFactory<i1.BrowserModule> = (null as any);
var _decl0_0:i2.CommonModule = (<any>(null as any));
var _decl0_1:i0.ApplicationModule = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef = (<any>(null as any));
export const BrowserTransferStateModuleNgFactory:i0.NgModuleFactory<i1.BrowserTransferStateModule> = (null as any);
var _decl1_0:i0.TemplateRef<any> = (<any>(null as any));
var _decl1_1:i0.ElementRef = (<any>(null as any));
